import Checkbox from '@components/Atoms/Checkbox';
import React, { FunctionComponent } from 'react';
import styles from './index.module.scss';

export interface ShareMyIdentityFieldProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
}

export const ShareMyIdentityField: FunctionComponent<ShareMyIdentityFieldProps> = ({
  checked,
  onCheckedChange,
  disabled = false,
  id = 'shareIdentity',
}) => {
  const explanationId = `${id}-explanation`;

  return (
    <div className={styles.root}>
      <div className={styles.middleDescriptionContainer}>
        <span className={styles.middleDescription} id={explanationId}>
          {checked ? (
            <>
              <span>Your name and email address will be shared</span> alongside your thoughts. If
              you&apos;d like to keep your thoughts anonymous, untick the box below.
            </>
          ) : (
            <>
              Your thoughts will be shared <span>anonymously</span>. However, if you&apos;d like
              your organisation to know who they&apos;re supporting, tick the box below.
            </>
          )}
        </span>
      </div>

      <div className={styles.checkContainer}>
        <Checkbox
          id={id}
          name={id}
          checked={checked}
          onChange={(event) => onCheckedChange(event.target.checked)}
          className={styles.roundedCheckbox}
          disabled={disabled}
          aria-describedby={explanationId}
        />
        <label className={styles.checkBoxTitle} htmlFor={id}>
          Share my identity
        </label>
      </div>
    </div>
  );
};

ShareMyIdentityField.displayName = 'ShareMyIdentityField';

ShareMyIdentityField.defaultProps = {
  disabled: false,
  id: 'shareIdentity',
};
